import { ModuleFE_Environment } from './ModuleFE_Environment.js';
export const ModulePackFE_Environment = [ModuleFE_Environment];
//# sourceMappingURL=module-pack.js.map